<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
  mounted() {
    // autofit.init({
    //   dh: 1080,
    //   dw: 1920,
    //   el: "body",
    //   resize: true
    // })
  },
}
</script>
<style lang="scss">
:root {
  --dada-bg-color: red;
}

#app {
  width: 100%;
  height: 100vh;
}

.el-main {
  padding: 0 !important;
}

.el-footer {
  padding: 0 !important;
}

.el-header {
  padding: 0 !important;
}

.el-aside {
  padding: 0 !important;
}

//.el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-bordered {
//  margin-left: 0 !important;
//}
</style>

